module.exports = "/_next/static/files/4b17905df0ededde1e38f5f22ced7a21.png";